import { Slider, Typography } from 'antd';
import { FC } from 'react';

import Utils from 'utils/utils';

import './index.scss';

type RangeSliderProps = {
	min: number;
	max: number;
	onChange: (v: number) => void;
	defaultValue: number;
	value: number;
	onAfterChange?: () => void;
	step?: number;
	isCalculator?: boolean;
	isMoney?: boolean;
	suffix?: string;
};

export const RangeSlider: FC<RangeSliderProps> = ({
	min,
	max,
	onChange,
	onAfterChange,
	defaultValue,
	value,
	step = 0.01,
	isCalculator,
	isMoney,
	suffix = '€',
}) => {
	return (
		<div className="rangeSlider">
			<Slider
				value={value}
				min={min}
				max={max}
				step={step}
				onChange={onChange}
				onAfterChange={onAfterChange}
				defaultValue={defaultValue}
				tooltip={{
					// @ts-ignore
					formatter: (e: number) => {
						return isMoney ? Utils.moneyFormat(e) : `${e} ${suffix}`;
					},
				}}
			/>
			<div className="rangeSlider__row">
				<Typography.Text type="secondary">
					{isMoney ? `${suffix} ${min}` : `${min} ${suffix}`}
				</Typography.Text>
				<Typography.Text type={isCalculator ? 'secondary' : 'danger'}>
					{isMoney ? `${suffix} ${max}` : `${max} ${suffix}`}
				</Typography.Text>
			</div>
		</div>
	);
};
